import c from './Socket.module.css'
import { finalizeSocket } from '../../../utils/api'
export const Socket = ({
  rtTaskId,
  isFinalized,
  onFinalize,
  output,
  rtSocket,
  dtSocket,
  setOpenSocketId,
}) => {

  const handleClick = () => {
    setOpenSocketId(rtSocket.id)
  }

  const handleCopyIdBtnClick = (event) => {
    // prevent bubbling to parent
    event.stopPropagation()
    navigator.clipboard.writeText(rtSocket.id)
  }

  const handleFinalizeBtn = (event) => {
    // prevent bubbling to parent
    event.stopPropagation()
    // TODO: Send finalize request
    finalizeSocket(rtTaskId, rtSocket.id)
    .then(response => {
      // console.log(response)
      if (response.error) {
        console.error(response.error)
        return
      }
      onFinalize(rtSocket.id)
    })
    .catch(error => {
      console.error(error)
    })
  }

  return (
    <div className={c['ctr']} onClick={handleClick}>
      [{isFinalized ? "F" : " "}] {rtSocket.name} <button onClick={handleCopyIdBtnClick}>CP</ button> <button onClick={handleFinalizeBtn}>FIN</button>
    </div>
  )
}
